import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'

import ModalCall from 'pages/admin/posCare/ModalCall'

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { formatDate, formatMoney } from 'helpers/helpers'

// Карточка точки глазами колл-центра: кому звонить и о чём говорили в прошлый раз.
//
// Две вкладки намеренно: контакты правят редко, а историю читают перед каждым
// звонком — смешивать их в один список значит листать справочник ради последней
// записи.
//
// Текст по-русски и без t(): админка не переводится (правило проекта).

const DIRECTION_TITLES = {
	out: 'Мы звонили',
	in: 'Нам звонили',
}

function getDefaultEmployee() {
	return {
		'full_name': '',
		'position_name': '',
		'phone': '',
		'phone_second': '',
		'comment': '',
		'is_primary': false,
	}
}

function ModalPosCard({ show, onHide, pos, topics = [], onChanged }) {
	const [card, setCard] = useState(null)
	const [tab, setTab] = useState('employees')

	const [employeeForm, setEmployeeForm] = useState(null)
	const [deletingId, setDeletingId] = useState(null)

	const [modalCall, setModalCall] = useState(false)
	const [selectedCall, setSelectedCall] = useState(null)

	async function getCard() {
		if (!pos) return

		const response = await GET(`/admin/pos-care/pos/${pos.id}`, {}, { loader: true })
		if (httpOk(response)) setCard(response.data)
	}

	async function saveEmployee(e) {
		e.preventDefault()

		var payload = {
			'full_name': employeeForm.full_name,
			'position_name': employeeForm.position_name,
			'phone': employeeForm.phone,
			'phone_second': employeeForm.phone_second,
			'comment': employeeForm.comment,
			'is_primary': employeeForm.is_primary,
		}

		var response
		if (!employeeForm.id) {
			response = await POST(`/admin/pos/${pos.id}/employees`, payload, { loader: true })
		} else {
			response = await PUT(`/admin/pos/${pos.id}/employees`, { ...payload, 'id': employeeForm.id }, { loader: true })
		}

		if (httpOk(response)) {
			setEmployeeForm(null)
			getCard()
			if (typeof onChanged === 'function') onChanged()
		}
	}

	async function deleteEmployee(id) {
		const response = await DELETE(`/admin/pos/${pos.id}/employees/${id}`, {}, { loader: true })

		if (httpOk(response)) {
			setDeletingId(null)
			getCard()
			if (typeof onChanged === 'function') onChanged()
		}
	}

	function toggleModalCall(bool = false, call = null) {
		setSelectedCall(call)
		setModalCall(bool)
	}

	function handleCallSaved() {
		getCard()
		setTab('calls')
		if (typeof onChanged === 'function') onChanged()
	}

	useEffect(() => {
		if (!show) return

		setCard(null)
		setTab('employees')
		setEmployeeForm(null)
		setDeletingId(null)
		getCard()
	}, [show, pos]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal show={show} animation={false} centered scrollable size="xl" onHide={onHide}>
				<Modal.Header closeButton>
					<Modal.Title>
						{pos?.name}
						<span className="ms-2 text-muted fs-6">{pos?.login}</span>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ 'minHeight': '420px' }}>
					{!card &&
						<div className="text-center text-muted">Загружаем…</div>
					}

					{card &&
						<>
							{/* Шапка: то, ради чего карточку открыли перед звонком —
								работает ли точка и сколько она нам должна */}
							<div className="d-flex flex-wrap gap-4 mb-3">
								<div>
									<div className="text-muted fs-6">Тип точки</div>
									<div>{card.pos.pos_type_name || '—'}</div>
								</div>
								{/* Склад чеков не пробивает — у него признак жизни приход или перемещение */}
								{card.pos.is_warehouse
									? <div>
										<div className="text-muted fs-6">Последний документ</div>
										<div className={card.pos.last_document_date ? '' : 'text-danger'}>
											{card.pos.last_document_date
												? formatDate(card.pos.last_document_date, 'dd.MM.yyyy HH:mm')
												: 'Никогда'}
										</div>
									</div>
									: <div>
										<div className="text-muted fs-6">Последний чек</div>
										<div className={card.pos.last_cheque_date ? '' : 'text-danger'}>
											{card.pos.last_cheque_date
												? formatDate(card.pos.last_cheque_date, 'dd.MM.yyyy HH:mm')
												: 'Никогда'}
										</div>
									</div>
								}
								<div>
									<div className="text-muted fs-6">Баланс</div>
									<div className={Number(card.pos.balance) < 0 ? 'text-danger' : ''}>
										{formatMoney(card.pos.balance)}
									</div>
								</div>
								<div>
									<div className="text-muted fs-6">Тариф</div>
									<div>{formatMoney(card.pos.tariff)}</div>
								</div>
								<div>
									<div className="text-muted fs-6">Город</div>
									<div>{[card.pos.district_name, card.pos.region_name].filter((item) => !!item).join(', ') || '—'}</div>
								</div>
								<div>
									<div className="text-muted fs-6">Телефон точки</div>
									<div>{card.pos.phone || '—'}</div>
								</div>

								<button className="btn btn-primary ms-auto align-self-center"
									onClick={() => toggleModalCall(true)}>
									<i className="uil uil-phone me-1"></i>
									Записать звонок
								</button>
							</div>

							<ul className="nav nav-tabs mb-3">
								<li className="nav-item">
									<button className={`nav-link ${tab === 'employees' ? 'active' : ''}`}
										onClick={() => setTab('employees')}>
										Сотрудники [{card.employees.length}]
									</button>
								</li>
								<li className="nav-item">
									<button className={`nav-link ${tab === 'calls' ? 'active' : ''}`}
										onClick={() => setTab('calls')}>
										Звонки [{card.calls.length}]
									</button>
								</li>
							</ul>

							{tab === 'employees' &&
								<>
									{!employeeForm &&
										<button className="btn btn-sm btn-outline-primary mb-2"
											onClick={() => setEmployeeForm(getDefaultEmployee())}>
											Добавить сотрудника
										</button>
									}

									{/* Форма прямо в карточке, а не вложенной модалкой: контакт
										заводят по ходу разговора, и лишнее окно поверх окна мешает */}
									{employeeForm &&
										<form className="card mb-3" onSubmit={saveEmployee} autoComplete="off">
											<div className="card-body py-2">
												<div className="row">
													<div className="col-md-4">
														<div className="form-group">
															<label>ФИО <span className="text-danger">*</span></label>
															<input type="text" className="form-control" autoFocus
																value={employeeForm.full_name}
																onChange={(e) => setEmployeeForm({ ...employeeForm, 'full_name': e.target.value })} />
														</div>
													</div>
													<div className="col-md-4">
														<div className="form-group">
															<label>Должность</label>
															<input type="text" className="form-control"
																placeholder="Директор, управляющий, бухгалтер"
																value={employeeForm.position_name || ''}
																onChange={(e) => setEmployeeForm({ ...employeeForm, 'position_name': e.target.value })} />
														</div>
													</div>
													<div className="col-md-2">
														<div className="form-group">
															<label>Телефон</label>
															<input type="text" className="form-control"
																placeholder="998901234567"
																value={employeeForm.phone || ''}
																onChange={(e) => setEmployeeForm({ ...employeeForm, 'phone': e.target.value })} />
														</div>
													</div>
													<div className="col-md-2">
														<div className="form-group">
															<label>Второй телефон</label>
															<input type="text" className="form-control"
																value={employeeForm.phone_second || ''}
																onChange={(e) => setEmployeeForm({ ...employeeForm, 'phone_second': e.target.value })} />
														</div>
													</div>
												</div>

												<div className="form-group">
													<label>Комментарий</label>
													<input type="text" className="form-control"
														placeholder="Когда удобно звонить, на что жаловался"
														value={employeeForm.comment || ''}
														onChange={(e) => setEmployeeForm({ ...employeeForm, 'comment': e.target.value })} />
												</div>

												<div className="d-flex align-items-center">
													<div className="form-check form-switch mb-0">
														<input type="checkbox" className="form-check-input" id="employeePrimary"
															checked={!!employeeForm.is_primary}
															onChange={(e) => setEmployeeForm({ ...employeeForm, 'is_primary': e.target.checked })} />
														<label className="form-check-label" htmlFor="employeePrimary">Звонить первым</label>
													</div>

													<div className="ms-auto">
														<button type="button" className="btn btn-sm btn-warning me-2"
															onClick={() => setEmployeeForm(null)}>
															Отмена
														</button>
														<button type="submit" className="btn btn-sm btn-primary"
															disabled={!employeeForm.full_name}>
															Сохранить
														</button>
													</div>
												</div>
											</div>
										</form>
									}

									<table className="table table-bordered mb-0">
										<thead>
											<tr>
												<th>ФИО</th>
												<th>Должность</th>
												<th>Телефоны</th>
												<th>Комментарий</th>
												<th>Последний звонок</th>
												<th style={{ 'width': '150px' }}></th>
											</tr>
										</thead>
										<tbody>
											{card.employees.map((item) => (
												<tr key={item.id}>
													<td>
														{item.full_name}
														{item.is_primary &&
															<span className="badge bg-primary ms-1">первый</span>
														}
													</td>
													<td>{item.position_name || '—'}</td>
													<td>
														<div>{item.phone || '—'}</div>
														{item.phone_second &&
															<div className="text-muted fs-6">{item.phone_second}</div>
														}
													</td>
													<td>{item.comment || '—'}</td>
													<td>
														{item.last_call_at
															? formatDate(item.last_call_at, 'dd.MM.yyyy')
															: <span className="text-muted">не говорили</span>}
													</td>
													<td className="text-end">
														{deletingId === item.id
															? <>
																<span className="me-2">Удалить?</span>
																<button className="btn btn-sm btn-danger me-1"
																	onClick={() => deleteEmployee(item.id)}>Да</button>
																<button className="btn btn-sm btn-outline-secondary"
																	onClick={() => setDeletingId(null)}>Нет</button>
															</>
															: <>
																<button className="btn btn-sm btn-outline-primary me-1"
																	onClick={() => setEmployeeForm({ ...getDefaultEmployee(), ...item })}>
																	<i className="uil uil-edit-alt"></i>
																</button>
																<button className="btn btn-sm btn-outline-danger"
																	onClick={() => setDeletingId(item.id)}>
																	<i className="uil uil-trash-alt"></i>
																</button>
															</>
														}
													</td>
												</tr>
											))}

											{card.employees.length === 0 &&
												<tr>
													<td colSpan="6" className="text-center text-muted">
														Контактов нет — звонить некому
													</td>
												</tr>
											}
										</tbody>
									</table>
								</>
							}

							{tab === 'calls' &&
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'width': '140px' }}>Когда</th>
											<th style={{ 'width': '120px' }}>Кто звонил</th>
											<th>С кем говорили</th>
											<th>Тема</th>
											<th>О чём</th>
											<th style={{ 'width': '140px' }}>Наш сотрудник</th>
											<th style={{ 'width': '50px' }}></th>
										</tr>
									</thead>
									<tbody>
										{card.calls.map((item) => (
											<tr key={item.id}>
												<td>{formatDate(item.called_at, 'dd.MM.yyyy HH:mm')}</td>
												<td>
													<span className={`badge ${item.direction === 'in' ? 'bg-info' : 'bg-secondary'}`}>
														{DIRECTION_TITLES[item.direction]}
													</span>
													{!item.is_answered &&
														<div className="text-danger fs-6">не дозвонились</div>
													}
												</td>
												<td>
													<div>{item.contact_name || '—'}</div>
													<div className="text-muted fs-6">{item.phone || ''}</div>
												</td>
												<td>
													{item.topic_name || '—'}
													{item.has_problem &&
														<div className="text-danger fs-6">проблема</div>
													}
													{item.outcome_name && <div><span className="badge bg-primary">{item.outcome_name}</span></div>}
													{item.promised_pay_at &&
														<div className="fs-6">обещали оплатить до {formatDate(item.promised_pay_at, 'dd.MM.yyyy')}</div>
													}
													{item.churn_reason_name && <div className="fs-6 text-danger">причина: {item.churn_reason_name}</div>}
													{item.next_call_at && <div className="fs-6 text-muted">перезвон {formatDate(item.next_call_at, 'dd.MM.yyyy')}</div>}
												</td>
												<td>{item.comment || '—'}</td>
												<td>{item.created_by_name || item.created_by || '—'}</td>
												<td className="text-end">
													<button className="btn btn-sm btn-outline-primary"
														onClick={() => toggleModalCall(true, item)}>
														<i className="uil uil-edit-alt"></i>
													</button>
												</td>
											</tr>
										))}

										{card.calls.length === 0 &&
											<tr>
												<td colSpan="7" className="text-center text-muted">
													С этой точкой ещё не разговаривали
												</td>
											</tr>
										}
									</tbody>
								</table>
							}
						</>
					}
				</Modal.Body>
			</Modal>

			{/* MODAL — форма звонка поверх карточки: точку выбирать не надо, она известна */}
			<ModalCall
				show={modalCall}
				onHide={() => toggleModalCall()}
				pos={pos}
				call={selectedCall}
				topics={topics}
				onSaved={handleCallSaved}
			/>
		</>
	)
}

export default ModalPosCard
